module.exports = __webpack_public_path__ + "files/d51154845162b217edd2c57baec947f7.png";